import React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@roc/ui';
import { makeStyles } from '@material-ui/core/styles';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { TitleCommitmentContent } from './titleCommitmentContent';

export interface TitleCommitmentDialogProps {
  open: boolean;
  onClose: () => void;
  taskId?: number;
}

const useStyles = makeStyles(theme => ({
  closeButton: {
    border: '1px solid #D0D0D0',
    color: theme.palette.text.primary,
    textTransform: 'none',
    fontWeight: 600,
    marginRight: theme.spacing(1),
    '&:hover': {
      backgroundColor: '#FAFAFA',
    },
  },
}));

export const TitleCommitmentDialog = observer(
  ({ open, onClose, taskId }: TitleCommitmentDialogProps) => {
    const classes = useStyles();
    return (
      <>
        {taskId && (
          <CustomTaskDialog
            open={open}
            title="Title Commitment"
            taskId={taskId}
            handleClose={onClose}
            maxWidth="lg"
            allowVertScroll={false}
            dialogContent={<TitleCommitmentContent taskId={taskId} onClose={onClose} />}
            dialogActions={
              <Button
                className={classes.closeButton}
                variant="outlined"
                onClick={onClose}
                testId="title-commitment-modal-close"
              >
                Close
              </Button>
            }
          />
        )}
      </>
    );
  }
);
